import React, { useEffect, useState } from 'react'
import Banner from './Banner'
import './About.css'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'

import SendIcon from '@mui/icons-material/Send';

const Privacy = ({ galleryRef, contactRef }) => {
    const pageName = "Privacy Policy"

    return (
        <>
            <Banner pageName={pageName} />
            <section className='abt_cont'>
                <div className='container'>
                    <article>
                        <div className='d-flex mb-6 mt-3 flex-column align-items-end'>
                            <p className="text-muted mb-1">Effective Date: 8 August 2026</p>
                            <p className="text-muted">Last Updated: 8 August 2026</p>
                        </div>

                        <h1 className="text-center mb-5 uppercase fw-bold w-100 mt-4" style={{color: "#5e79bc", lineHeight: "65px", textTransform: "uppercase", fontSize: "32px" }}> 
                            Welcome to Car Genie, a brand operated by BM Enterprises <br/> ("BM Enterprises", "we", "us", or "our"). 
                        </h1>

                        <h3 className="mb-5" style={{color: "#6d6c6c", lineHeight: "50px", fontWeight: 300}}>
                            Car Genie is a multi-brand automotive service and repair brand providing services including vehicle servicing, mechanical repairs, denting and painting,
                            detailing, polishing, ceramic coating, PPF, insurance claim assistance and related automotive services.
                        </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            This Privacy Policy explains how we collect, use, store and protect your personal information when you visit our website, contact us, submit an enquiry, request a service, or otherwise interact with Car Genie.
                        </p>

                        <h3 style={{color: "#5e79bc"}}> <span>1.</span> Information We Collect </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            Depending on how you interact with us, we may collect:
                        </p>

                        <ul style={{color: "#4b4a4a", lineHeight: "40px", fontSize: "18px"}} className='mb-3 w-100'>
                            <li>•⁠  Name</li>
                            <li>•⁠  Mobile number</li>
                            <li>•⁠  Email address</li>
                            <li>•⁠  Address or location information</li>
                            <li>•⁠  Vehicle registration number</li>
                            <li>•⁠  Vehicle make, model and variant</li>
                            <li>•⁠  Vehicle-related service and repair information</li>
                            <li>•⁠  Insurance-related information where required for claim assistance</li>
                            <li>•⁠  Information submitted through website enquiry or booking forms</li>
                            <li>•⁠  Payment and transaction-related information</li>
                            <li>•⁠  Photographs or videos of your vehicle where required for inspection, assessment or service documentation</li>
                            <li>•⁠  Any other information voluntarily provided by you</li>
                        </ul>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-3'>
                            We may also automatically collect certain technical information when you use our website, such as IP address, browser type, device information, pages visited and general website usage information.
                        </p>

                        <h3 className='mt-5 w-100' style={{color: "#5e79bc"}}> <span>2.</span> How We Use Your Information </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-3'>We may use the information collected to: </p>

                        <ul style={{color: "#4b4a4a", lineHeight: "40px", fontSize: "18px"}} className='mb-5 w-100'>
                            <li>•⁠  Respond to your enquiries and requests</li>
                            <li>•⁠  Schedule and manage vehicle services</li>
                            <li>•⁠  Provide repair, maintenance and other automotive services</li>
                            <li>•⁠  Prepare estimates, invoices and service records</li>
                            <li>•⁠  Communicate with you regarding your vehicle or service</li>
                            <li>•⁠  Assist with insurance-related processes where requested or authorised by you</li>
                            <li>•⁠  Process payments and transactions</li>
                            <li>•⁠  Improve our services, website and customer experience</li>
                            <li>•⁠  Maintain business and accounting records</li>
                            <li>•⁠  Send service-related notifications</li>
                            <li>•⁠  Send promotional offers, updates and marketing communications where permitted</li>
                            <li>•⁠  Prevent fraud, misuse or unauthorised activities</li>
                            <li>•⁠  Comply with applicable legal and regulatory requirements</li>
                        </ul>

                        <h3 style={{color: "#5e79bc"}}> <span>3.</span> Sharing of Information </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            We do not sell or rent your personal information to third parties.
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            Where reasonably necessary to provide our services, information may be shared with:
                        </p>

                        <ul style={{color: "#4b4a4a", lineHeight: "40px", fontSize: "18px"}} className='mb-3'>
                            <li>•⁠  Service providers and technology partners supporting our operations</li>
                            <li>•⁠  Payment processing providers</li>
                            <li>•⁠  Insurance companies, surveyors or claim-related parties where authorised or required</li>
                            <li>•⁠  Vehicle manufacturers, dealerships or other automotive service partners where necessary for the requested service</li>
                            <li>•⁠  Government authorities, regulators or law-enforcement agencies where legally required</li>
                            <li>•⁠  Professional advisers, auditors or other authorised business partners</li>
                        </ul>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>We only seek to share information that is reasonably necessary for the relevant purpose.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>4.</span> Marketing Communications </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>With your consent or where otherwise permitted by applicable law, we may contact you through telephone calls, SMS, WhatsApp, email or other communication channels regarding our services, offers and promotions.</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>You may request that we stop sending promotional communications at any time.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>5.</span> Cookies and Similar Technologies </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>Our website may use cookies and similar technologies to improve website functionality, understand visitor behaviour, analyse website traffic and improve our marketing activities.</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>You may manage or disable cookies through your browser settings. Certain website functions may not operate properly if cookies are disabled.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>6.</span> Data Security </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>We take reasonable technical and organisational measures to protect personal information against unauthorised access, misuse, alteration, disclosure or destruction.</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>However, no method of transmitting or storing information electronically can be guaranteed to be completely secure.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>7.</span> Data Retention </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>We retain personal information only for as long as reasonably necessary for the purposes described in this Privacy Policy, including providing services, maintaining business records, resolving disputes, complying with legal requirements and protecting our legitimate business interests.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>8.</span> Third-Party Websites and Services </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>Our website may contain links, integrations or references to third-party websites, applications or services.</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}> BM Enterprises / Car Genie is not responsible for the privacy practices, content or security of third-party websites. We recommend reviewing the privacy policies of such third parties before providing them with personal information.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>9.</span> Children's Privacy </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>Our services are intended for adults and vehicle owners/customers. We do not knowingly collect personal information from children for the purpose of providing our services.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>10.</span> Your Rights and Requests </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>Subject to applicable law, you may contact us regarding:</p>

                        <ul style={{color: "#4b4a4a", lineHeight: "40px", fontSize: "18px"}}>
                            <li>•⁠  Access to personal information held by us</li>
                            <li>•⁠  Correction of inaccurate information</li>
                            <li>•⁠  Withdrawal of consent where applicable</li>
                            <li>•⁠  Requests relating to the use or retention of your personal information</li>
                            <li>•⁠  Opting out of promotional communications</li>
                        </ul>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>We may need to verify your identity before processing certain requests.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>11.</span> Changes to this Privacy Policy </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>We may update this Privacy Policy from time to time to reflect changes in our services, technology, legal requirements or business practices.</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>Any updated version will be published on this page with a revised "Last Updated" date.</p>

                        <h3 style={{color: "#5e79bc"}} className='mt-5'> <span>12.</span> Contact Us </h3>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} >For privacy-related questions, requests or concerns, please contact:</p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>BM Enterprises</b> <br/>
                            <b>Brand:</b> Car Genie
                        </p>

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Email:</b> <a href="mailto: care@cargenie.co.in "> care@cargenie.co.in </a>
                        </p>
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Phone:</b> <a href="tel: +917003900368"> +91-7003900368  </a>
                        </p>
                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}} className='mb-2'>
                            <b>Address:</b> <address>1, RIC Bazar, Dunlop,
                                Bonhooghly Government Colony,
                                Kolkata, Baranagar
                                West Bengal 700108
                            </address>
                        </p>
                        

                        <p style={{color: "#4b4a4a", lineHeight: "33px", fontSize: "18px"}}>
                            By using our website or providing information to us, you acknowledge that you have read and understood this Privacy Policy.
                        </p>
                    </article>
                </div>
            </section>

        </>
    )
}

export default Privacy